export const ADD_CONTACT = 'ADD_CONTACT';
export const ADD_IGNORED_ERROR = 'ADD_IGNORED_ERROR';
export const ADD_NOTE = 'ADD_NOTE';
export const SET_PRACTICE_GROUPS = 'SET_PRACTICE_GROUPS';
export const CLIENT_PLUGIN_REMOVED = 'CLIENT_PLUGIN_REMOVED';
export const CLIENT_PLUGIN_SETCONFIGURATIONS =
    'CLIENT_PLUGIN_SETCONFIGURATIONS';
export const CLIENT_PLUGIN_RESET_CONFIGURATIONS =
    'CLIENT_PLUGIN_RESET_CONFIGURATIONS';
export const CLIENT_PLUGIN_SETNOTES = 'CLIENT_PLUGIN_SETNOTES';
export const CLIENT_PLUGIN_RESET_NOTES = 'CLIENT_PLUGIN_RESET_NOTES';
export const CLIENT_PLUGIN_RESET_CONFIGURATIONBYPLUGIN =
    'CLIENT_PLUGIN_RESET_CONFIGURATIONBYPLUGIN';
export const CLIENT_PLUGIN_RESET_NOTEBYPLUGIN =
    'CLIENT_PLUGIN_RESET_NOTEBYPLUGIN';
export const COMMUNICATIONS_ERROR = 'COMMUNICATIONS_ERROR';
export const CONNECTIVITY_ERROR = 'CONNECTIVITY_ERROR';
export const CREATE_SYNC_SCHEDULE = 'CREATE_SYNC_SCHEDULE';
export const MSC_FETCH_PLUGINS_REQUEST = 'MSC_FETCH_PLUGINS_REQUEST';
export const MSC_FETCH_PLUGINS_RESULT = 'MSC_FETCH_PLUGINS_RESULT';
export const MSC_FETCH_PLUGIN_REQUEST = 'MSC_FETCH_PLUGIN_REQUEST';
export const MSC_GET_ALL_PLUGINS = 'MSC_GET_ALL_PLUGINS';
export const MSC_GET_PLUGIN = 'MSC_GET_ALL_PLUGINS';
export const MSC_GET_PLUGINS_FOR_PRACTICE = 'MSC_GET_PLUGINS_FOR_PRACTICE';
export const MSC_GET_CURRENT_PAGE = 'MSC_GET_CURRENT_PAGE';
export const MSC_PLUGIN_ERROR = 'MSC_PLUGIN_ERROR';
export const MSC_SET_FILTER = 'MSC_SET_FILTER';
export const MSC_SET_PIMS_FILTER = 'MSC_SET_PIMS_FILTER';
export const MSC_SET_CURRENT_PAGE = 'MSC_SET_CURRENT_PAGE';
export const MSC_SET_TOTAL_PAGES = 'MSC_SET_TOTAL_PAGES';
export const MSC_SET_PLUGIN_ID = 'MSC_SET_PLUGIN_ID';
export const MSC_SET_INCLUDE_INACTIVE_PLUGINS =
    'MSC_SET_INCLUDE_INACTIVE_PLUGINS';
export const MSC_SEARCHING_FOR_PLUGINS = 'MSC_SEARCHING_FOR_PLUGINS';
export const MSC_SET_EDITMODAL_ACTIVE_PLUGIN =
    'MSC_SET_EDITMODAL_ACTIVE_PLUGIN';
export const MSC_SET_EDITMODAL_ACTIVE_PLUGIN_ID =
    'MSC_SET_EDITMODAL_ACTIVE_PLUGIN_ID';
export const MSC_SET_EDITMODAL_PLUGIN_STATUS =
    'MSC_SET_EDITMODAL_PLUGIN_STATUS';
export const MSC_SET_PLUGIN_ISINACTIVE = 'MSC_SET_PLUGIN_ISINACTIVE';
export const MSC_SET_EDITMODAL_PLUGIN_DEPENDENCIES =
    'MSC_SET_EDITMODAL_PLUGIN_DEPENDENCIES';
export const MSC_REMOVE_EDITMODAL_PLUGIN_DEPENDENCY =
    'MSC_REMOVE_EDITMODAL_PLUGIN_DEPENDENCY';
export const MSC_RESET_EDITMODAL_PLUGIN_DEPENDENCIES =
    'MSC_RESET_EDITMODAL_PLUGIN_DEPENDENCIES';
export const MSC_SOURCESTATE_EDITMODAL_PLUGIN_DEPENDENCIES =
    'MSC_SOURCESTATE_EDITMODAL_PLUGIN_DEPENDENCIES';
export const MSC_RESETSOURCESTATE_EDITMODAL_PLUGIN_DEPENDENCIES =
    'MSC_RESETSOURCESTATE_EDITMODAL_PLUGIN_DEPENDENCIES';
export const MSC_SET_EDITMODAL_PIMS_DEPENDENCIES =
    'MSC_SET_EDITMODAL_PIMS_DEPENDENCIES';
export const MSC_REMOVE_EDITMODAL_PIMS_DEPENDENCY =
    'MSC_REMOVE_EDITMODAL_PIMS_DEPENDENCY';
export const MSC_RESET_EDITMODAL_PIMS_DEPENDENCIES =
    'MSC_RESET_EDITMODAL_PIMS_DEPENDENCIES';
export const MSC_SOURCESTATE_EDITMODAL_PIMS_DEPENDENCIES =
    'MSC_SOURCESTATE_EDITMODAL_PIMS_DEPENDENCIES';
export const MSC_RESETSOURCESTATE_EDITMODAL_PIMS_DEPENDENCIES =
    'MSC_RESETSOURCESTATE_EDITMODAL_PIMS_DEPENDENCIES';
export const MSC_SET_EDITMODAL_PLUGIN_VERSION =
    'MSC_SET_EDITMODAL_PLUGIN_VERSION';
export const MSC_UPDATE_EDITMODAL_PLUGIN_VERSION =
    'MSC_UPDATE_EDITMODAL_PLUGIN_VERSION';
export const MSC_REMOVE_EDITMODAL_PLUGIN_VERSION =
    'MSC_REMOVE_EDITMODAL_PLUGIN_VERSION';
export const MSC_RESET_EDITMODAL_PLUGIN_VERSION =
    'MSC_RESET_EDITMODAL_PLUGIN_VERSION';
export const MSC_SOURCESTATE_EDITMODAL_PLUGIN_VERSION =
    'MSC_SOURCESTATE_EDITMODAL_PLUGIN_VERSION';
export const MSC_RESETSOURCESTATE_EDITMODAL_PLUGIN_VERSION =
    'MSC_RESETSOURCESTATE_EDITMODAL_PLUGIN_VERSION';
export const MSC_SET_SELECTED_PLUGIN_DEFAULTVERSION =
    'MSC_SET_SELECTED_PLUGIN_DEFAULTVERSION';

// Daylight
export const DAYLIGHT_MARK_CODE_MAPPING_FOR_REVIEW =
    'DAYLIGHT_MARK_CODE_MAPPING_FOR_REVIEW';
export const DAYLIGHT_UNMARK_CODE_MAPPING_FOR_REVIEW =
    'DAYLIGHT_UNMARK_CODE_MAPPING_FOR_REVIEW';
export const DAYLIGHT_REMOVE_CODE_MAPPING = 'DAYLIGHT_REMOVE_CODE_MAPPING';
export const DAYLIGHT_MARK_CODE_COMPLETE = 'DAYLIGHT_MARK_CODE_COMPLETE';
export const DAYLIGHT_UNMARK_CODE_COMPLETE = 'DAYLIGHT_UNMARK_CODE_COMPLETE';
export const SET_DAYLIGHT_SELECTED_CODE_USAGE_DETAIL =
    'SET_DAYLIGHT_SELECTED_CODE_USAGE_DETAIL';
export const SET_DAYLIGHT_PRACTICE_FINALIZED_STATUS =
    'SET_DAYLIGHT_PRACTICE_FINALIZED_STATUS';
export const SET_DAYLIGHT_IS_LOADING_CODES = 'SET_DAYLIGHT_IS_LOADING_CODES';
export const SET_DAYLIGHT_CODES_FILTER_CODE_NAME =
    'SET_DAYLIGHT_CODES_FILTER_CODE_NAME';
export const SET_DAYLIGHT_CODES_FILTER_CODE_CATEGORY =
    'SET_DAYLIGHT_CODES_FILTER_CODE_CATEGORY';
export const SET_DAYLIGHT_CODES_FILTER_CODE_DESCRIPTION =
    'SET_DAYLIGHT_CODES_FILTER_CODE_DESCRIPTION';
export const SET_DAYLIGHT_CODES_FILTER_CODE_LOCATION =
    'SET_DAYLIGHT_CODES_FILTER_CODE_LOCATION';
export const SET_DAYLIGHT_CODES_FILTER_CODE_MAPPING =
    'SET_DAYLIGHT_CODES_FILTER_CODE_MAPPING';
export const SET_DAYLIGHT_CODES_FILTER_CODE_HAS_COMMENTS =
    'SET_DAYLIGHT_CODES_FILTER_CODE_HAS_COMMENTS';
export const SET_DAYLIGHT_CODES_FILTER_CODE_IS_MARKED_COMPLETED =
    'SET_DAYLIGHT_CODES_FILTER_CODE_IS_MARKED_COMPLETED';
export const SET_DAYLIGHT_CODES_FILTER_CODE_NEEDS_REVIEW =
    'SET_DAYLIGHT_CODES_FILTER_CODE_NEEDS_REVIEW';
export const SET_DAYLIGHT_CODES_FILTER_MARKED_DISABLED =
    'SET_DAYLIGHT_CODES_FILTER_MARKED_DISABLED';
export const SET_DAYLIGHT_UPDATING_CODE_ID = 'SET_DAYLIGHT_UPDATING_CODE_ID';
export const SET_DAYLIGHT_TARGET_CODE_FOR_ACTION =
    'SET_DAYLIGHT_TARGET_CODE_FOR_ACTION';
export const SET_DAYLIGHT_TARGET_MAPPING_FOR_ACTION =
    'SET_DAYLIGHT_TARGET_MAPPING_FOR_ACTION';
export const SET_DAYLIGHT_ADD_MAPPING_MODAL_OPEN =
    'SET_DAYLIGHT_ADD_MAPPING_MODAL_OPEN';
export const SET_DAYLIGHT_EDIT_MAPPING_MODAL_OPEN =
    'SET_DAYLIGHT_EDIT_MAPPING_MODAL_OPEN';
export const SET_DAYLIGHT_USER_HAS_ACCESS_TO_USAGE_DETAILS =
    'SET_DAYLIGHT_USER_HAS_ACCESS_TO_USAGE_DETAILS';
export const SET_DAYLIGHT_MAPPING_COMMENT_MODAL_OPEN =
    'SET_DAYLIGHT_MAPPING_COMMENT_MODAL_OPEN';
export const ADD_DAYLIGHT_MAPPING = 'ADD_DAYLIGHT_MAPPING';
export const SET_DAYLIGHT_MAPPING = 'SET_DAYLIGHT_MAPPING';
export const SET_DAYLIGHT_MAPPING_COMMENT = 'SET_DAYLIGHT_MAPPING_COMMENT';
export const SET_DAYLIGHT_CODES_DISPLAYED_COUNT =
    'SET_DAYLIGHT_CODES_DISPLAYED_COUNT';
export const SET_DAYLIGHT_CODE = 'SET_DAYLIGHT_CODE';
export const SET_DAYLIGHT_UPDATING_MAPPING_ID =
    'SET_DAYLIGHT_UPDATING_MAPPING_ID';
export const SET_DAYLIGHT_SELECTED_PARTNER_ID =
    'SET_DAYLIGHT_SELECTED_PARTNER_ID';

export const DELETE_IGNORED_ERROR = 'DELETE_IGNORED_ERROR';
export const EVENTS_ERROR = 'EVENTS_ERROR';
export const FETCH_ADMIN_USERS_REQUEST = 'FETCH_ADMIN_USERS_REQUEST';
export const FETCH_ALL_IGNORED_ERRORS = 'FETCH_ALL_IGNORED_ERRORS';
export const FETCH_COMMUNICATIONS_REQUEST = 'FETCH_COMMUNICATIONS_REQUEST';
export const FETCH_CONNECTIVITY_REQUEST = 'FETCH_CONNECTIVITY_REQUEST';
export const FETCH_EVENTS_REQUEST = 'FETCH_EVENTS_REQUEST';
export const FETCH_GROUPS_REQUEST = 'FETCH_GROUPS_REQUEST';
export const FETCH_NOTES_REQUEST = 'FETCH_NOTES_REQUEST';
export const FETCH_OFFERING_ERROR = 'FETCH_OFFERING_ERROR';
export const FETCH_OFFERING_REQUEST = 'FETCH_OFFERING_REQUEST';
export const FETCH_PARTNER_REQUEST = 'FETCH_PARTNER_REQUEST';
export const FETCH_PRACTICES_REQUEST = 'FETCH_PRACTICES_REQUEST';
export const FETCH_PRACTICES_RESULT = 'FETCH_PRACTICES_RESULT';
export const FETCH_PRACTICE_REQUEST = 'FETCH_PRACTICE_REQUEST';
export const FETCH_RELATIONS_REQUEST = 'FETCH_RELATIONS_REQUEST';
export const FETCH_SESSION = 'FETCH_SESSION';
export const FETCH_TAGS_REQUEST = 'FETCH_TAGS_REQUEST';
export const FETCH_USERS = 'FETCH_USERS';
export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST';
export const FILTER_PRACTICE_RELATIONS = 'FILTER_PRACTICE_RELATIONS';
export const GET_ALL_COMMUNICATIONS = 'GET_ALL_COMMUNICATIONS';
export const GET_ALL_IGNORED_ERRORS = 'GET_ALL_IGNORED_ERRORS';
export const GET_ALL_PARTNERS = 'GET_ALL_PARTNERS';
export const GET_ALL_PIMS = 'GET_ALL_PIMS';
export const GET_ALL_PRACTICES = 'GET_ALL_PRACTICES';
export const GET_ALL_SHARD_REGIONS = 'GET_ALL_SHARD_REGIONS';
export const GET_COMMENTS = 'GET_COMMENTS';
export const GET_COMMENT_TEXT = 'GET_COMMENT_TEXT';
export const GET_COMMUNICATION = 'GET_COMMUNICATION';
export const GET_COMMUNICATION_LIST = 'GET_COMMUNICATION_LIST';
export const GET_CONNECTIVITY = 'GET_CONNECTIVITY';
export const GET_CURRENT_OFFERINGS = 'GET_CURRENT_OFFERINGS';
export const GET_CURRENT_PAGE = 'GET_CURRENT_PAGE';
export const GET_EMPTY_COMMUNICATION = 'GET_EMPTY_COMMUNICATION';
export const GET_EMPTY_NOTE = 'GET_EMPTY_NOTE';
export const GET_EVENTS = 'GET_EVENTS';
export const GET_FILTERED_RELATIONS = 'GET_FILTERED_RELATIONS';
export const GET_FIRST_ACTIVE_PRACTICE_ID = 'GET_FIRST_ACTIVE_PRACTICE_ID';
export const GET_FIRST_PRACTICE = 'GET_FIRST_PRACTICE';
export const GET_FIRST_STALE_PRACTICE_ID = 'GET_FIRST_STALE_PRACTICE_ID';
export const GET_GROUPS = 'GET_GROUPS';
export const GET_INSTANCE_FORM = 'GET_INSTANCE_FORM';
export const GET_NOTES = 'GET_NOTES';
export const GET_OFFERINGS = 'GET_OFFERINGS';
export const GET_PARTNER = 'GET_PARTNER';
export const GET_PARTNER_OFFERINGS = 'GET_PARTNER_OFFERINGS';
export const GET_PRACTICE = 'GET_PRACTICE';
export const GET_PRACTICES_FOR_PARTNER = 'GET_PRACTICES_FOR_PARTNER';
export const GET_PRACTICE_CONFIG = 'GET_PRACTICE_CONFIG';
export const GET_PRACTICE_CONFIG_FORM = 'GET_PRACTICE_CONFIG_FORM';
export const GET_RELATIONS = 'GET_RELATIONS';
export const GET_RRULE = 'GET_RRULE';
export const GET_SCHEDULES = 'GET_SCHEDULES';
export const GET_SELECTED_COMMUNICATION_PARTNER =
    'GET_SELECTED_COMMUNICATION_PARTNER';
export const GET_SELECTED_OFFERING = 'GET_SELECTED_OFFERING';
export const GET_SELECTED_OFFERING_PARTNER = 'GET_SELECTED_OFFERING_PARTNER';
export const GET_SELECTED_PARTNER = 'GET_SELECTED_PARTNER';
export const GET_SESSION = 'GET_SESSION';
export const GET_SINGLE_GROUP = 'GET_SINGLE_GROUP';
export const GET_SINGLE_RELATION = 'GET_SINGLE_RELATION';
export const GET_SINGLE_TAG = 'GET_SINGLE_TAG';
export const GET_SOME_PARTNERS = 'GET_SOME_PARTNERS';
export const GET_SOME_PARTNER_RELATIONS = 'GET_SOME_PARTNER_RELATIONS';
export const GET_SOME_PRACTICES = 'GET_SOME_PRACTICES';
export const GET_SOME_RELATIONS = 'GET_SOME_RELATIONS';
export const GET_STATES = 'GET_STATES';
export const GET_TAGS = 'GET_TAGS';
export const GET_TAG_TYPES = 'GET_TAG_TYPES';
export const GET_TOTAL_PAGES = 'GET_TOTAL_PAGES';
export const GET_USERS = 'GET_USERS';
export const GET_LATEST_RUNTIME_EXTRACTION = 'GET_LATEST_RUNTIME_EXTRACTION';
export const GET_LATEST_RUNTIME_STAGING = 'GET_LATEST_RUNTIME_STAGING';
export const GET_LATEST_RUNTIME_INTERMEDIATE =
    'GET_LATEST_RUNTIME_INTERMEDIATE';
export const GET_LATEST_RUNTIME_INSTANCE_REPORT =
    'GET_LATEST_RUNTIME_INSTANCE_REPORT';
export const GET_LATEST_RUNTIME_CONVERSIONPREP =
    'GET_LATEST_RUNTIME_CONVERSIONPREP';
export const GET_LATEST_RUNTIME_LEADS_GENERATION =
    'GET_LATEST_RUNTIME_LEADS_GENERATION';
export const GROUPS_ERROR = 'GROUPS_ERROR';
export const IS_ADD_NEW_OFFERING_FORM_COLLAPSE_OPEN =
    'IS_ADD_NEW_OFFERING_FORM_COLLAPSE_OPEN';
export const IS_CONNECTIVITY_CONFIG_FORM_VALID =
    'IS_CONNECTIVITY_CONFIG_FORM_VALID';
export const IS_NOTE_BEING_ADDED = 'IS_NOTE_BEING_ADDED';
export const IS_OFFERING_PARTNER_SELECTED = 'IS_OFFERING_PARTNER_SELECTED';
export const IS_OFFERING_SELECTED = 'IS_OFFERING_SELECTED';
export const IS_PARTNER_CONNECTED = 'IS_PARTNER_CONNECTED';
export const IS_VIEW_ADDING_NEW_COMMUNICATION =
    'IS_VIEW_ADDING_NEW_COMMUNICATION';
export const NEW_CONNECITON_SELECTED_PRACTICE =
    'NEW_CONNECITON_SELECTED_PRACTICE';
export const NEW_CONNECTION_SELECTED_PARTNER =
    'NEW_CONNECTION_SELECTED_PARTNER';
export const NEW_CONTACT_INFO = 'NEW_CONTACT_INFO';
export const NEW_REQUEST_FORM_DISABLED = 'NEW_REQUEST_FORM_DISABLED';
export const NOTES_ERROR = 'NOTES_ERROR';
export const PARTNER_ERROR = 'PARTNER_ERROR';
export const POST_COMMUNICATION = 'POST_COMMUNICATION';
export const PRACTICES_WITH_NOTIFICATIONS = 'PRACTICES_WITH_NOTIFICATIONS';
export const PRACTICE_ERROR = 'PRACTICE_ERROR';
export const PRACTICE_TAB_SELECTED = 'PRACTICE_TAB_SELECTED';
export const UPDATE_PRACTICE_TAB = 'UPDATE_PRACTICE_TAB';
export const PRACTICE_TO_MUTE = 'PRACTICE_TO_MUTE';
export const USER_ASSIGNING_PRACTICE = 'USER_ASSIGNING_PRACTICE';
export const PUT_DEACTIVATED_RELATIONS = 'PUT_DEACTIVATED_RELATIONS';
export const PUT_FILTERED_RELATIONS = 'PUT_FILTERED_RELATIONS';
export const PUT_IGNORED_ERRORS = 'PUT_IGNORED_ERRORS';
export const PUT_REACTIVATED_RELATIONS = 'PUT_REACTIVATED_RELATIONS';
export const PUT_USERS = 'PUT_USERS';
export const REMOVE_RELATION_STEP2 = 'REMOVE_RELATION_STEP2';
export const RELATIONS_ERROR = 'RELATIONS_ERROR';
export const SAVEPARTNERINFO = 'SAVEPARTNERINFO';
export const SAVEPRACTICEINFO = 'SAVEPRACTICEINFO';
export const SAVE_CONTACT = 'SAVE_CONTACT';
export const SAVE_EDITED_CONTACT = 'SAVE_EDITED_CONTACT';
export const SAVE_NEW_PRACTICE = 'SAVE NEW PRACTICE';
export const SAVE_PARTNER_CONTACT_INFO = 'SAVE_PARTNER_CONTACT_INFO';
export const SAVE_PARTNER_INFO = 'SAVE_PARTNER_INFO';
export const SAVE_SYNC_SCHEDULE = 'SAVE_SYNC_SCHEDULE';
export const SEARCHING_FOR_PRACTICES = 'SEARCHING_FOR_PRACTICES';
export const SEARCH_PRACTICES_REQUEST = 'SEARCH_PRACTICES_REQUEST';
export const SEARCH_PRACTICES_RESULT = 'SEARCH_PRACTICES_RESULT';
export const SEARCH_PRACTICE_ERROR = 'SEARCH_PRACTICE_ERROR';
export const SELECT_PRACTICE = 'SELECT_PRACTICE';
export const SESSION_READY = 'SESSION_READY';
export const SET_ACCOUNT_INFO = 'SET_ACCOUNT_INFO';
export const SET_ACTIVE_COLLAPSE = 'SET_ACTIVE_COLLAPSE';
export const SET_ACTIVE_INACTIVE = 'SET_ACTIVE_INACTIVE';
export const SET_ACTIVE_LINK = 'SET_ACTIVE_LINK';
export const SET_ACTIVE_TAB_PRACTICES = 'SET_ACTIVE_TAB_PRACTICES';
export const SET_BOOKMARKED = 'SET_BOOKMARKED';
export const SET_CLICKED_GROUP = 'SET_CLICKED_GROUP';
export const SET_CLICKED_GROUP_ID = 'SET_CLICKED_GROUP_ID';
export const SET_CLICKED_TAG = 'SET_CLICKED_TAG';
export const SET_CLICKED_USER = 'SET_CLICKED_USER';
export const SET_COMMUNICATION_STATUS = 'SET_COMMUNICATION_STATUS';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const SET_DASHBOARD_STATS = 'SET_DASHBOARD_STATS';
export const SET_FILTER = 'SET_FILTER';
export const SET_FIRST_ACTIVE_PRACTICE_ID = 'SET_FIRST_ACTIVE_PRACTICE_ID';
export const SET_FIRST_PRACTICE_READY = 'SET_FIRST_PRACTICE_READY';
export const SET_FIRST_STALE_PRACTICE_ID = 'SET_FIRST_STALE_PRACTICE_ID';
export const SET_INCLUDE_TEST_PRACTICES = 'SET_INCLUDE_TEST_PRACTICES';
export const SET_INCLUDE_DORMANT_PRACTICES = 'SET_INCLUDE_DORMANT_PRACTICES';
export const SET_IS_COMMUNICAITON_PARTNER_SELECTED =
    'SET_IS_COMMUNICAITON_PARTNER_SELECTED';
export const SET_IS_COMMUNICATION_BEING_CREATED =
    'SET_IS_COMMUNICATION_BEING_CREATED';
export const SET_MENTIONABLE_COMMENT_USERS = 'SET_MENTIONABLE_COMMENT_USERS';
export const SET_NEW_REQUEST = 'SET_NEW_REQUEST';
export const SET_PRACTICE_NOTIFICATIONS = 'SET_PRACTICE_NOTIFICATIONS';
export const SET_ROLES = 'SET_ROLES';
export const SET_SCHEDULE_EDIT_INDEX = 'SET_SCHEDULE_EDIT_INDEX';
export const SET_SEARCH_ASSIGNED_PRACTICES = 'SET_SEARCH_ASSIGNED_PRACTICES';
export const SET_SEARCH_COMMUNICATIONS = 'SET_SEARCH_COMMUNICATIONS';
export const SET_SEARCH_GROUPS = 'SET_SEARCH_GROUPS';
export const SET_SEARCH_NOTES = 'SET_SEARCH_NOTES';
export const SET_SEARCH_CUSTOM_IDS = 'SET_SEARCH_CUSTOM_IDS';
export const SET_SELECTED_COMMUNICATION = 'SET_SELECTED_COMMUNICATION';
export const SET_STATUS = 'SET_STATUS';
export const SET_TOTAL_PAGES = 'SET_TOTAL_PAGES';
export const SET_USER_STATUS = 'SET_USER_STATUS';
export const SET_WORKFLOW_ACTIVE_PRACTICE = 'SET_WORKFLOW_ACTIVE_PRACTICE';
export const SET_WORKFLOW_ACTIVE_PRACTICE_ID =
    'SET_WORKFLOW_ACTIVE_PRACTICE_ID';
export const SET_WORKFLOW_PIMS = 'SET_WORKFLOW_PIMS';
export const SET_WORKFLOW_STATUS = 'SET_WORKFLOW_STATUS';
export const SET_WORKFLOW_PRACTICES = 'SET_WORKFLOW_PRACTICES';
export const SET_WORKFLOW_FILTER = 'SET_WORKFLOW_FILTER';
export const SET_RELATION_STEP2 = 'SET_RELATION_STEP2';
export const RESET_RELATION_STEP2 = 'RESET_RELATION_STEP2';
export const STORE_ADDED_COMMUNICATION = 'STORE_ADDED_COMMUNICATION';
export const STORE_ADDED_CONTACT = 'STORE_ADDED_CONTACT';
export const STORE_ADDED_REQUEST = 'STORE_ADDED_REQUEST';
export const STORE_RRULE = 'STORE_RRULE';
export const TAGS_ERROR = 'TAGS_ERROR';
export const TOGGLE_ASSIGN_MODAL = 'TOGGLE_ASSIGN_MODAL';
export const TOGGLE_ASSIGN_MODAL_DROPDOWN = 'TOGGLE_ASSIGN_MODAL_DROPDOWN';
export const TOGGLE_CONNECTIVITYMODAL = 'TOGGLE_CONNECTIVITYMODAL';
export const TOGGLE_CONNECTIVITYMODALPARTNERDROPDOWN =
    'TOGGLE_CONNECTIVITYMODALPARTNERDROPDOWN';
export const TOGGLE_CONNECTIVITYMODALPRACTICEDROPDOWN =
    'TOGGLE_CONNECTIVITYMODALPRACTICEDROPDOWN';
export const TOGGLE_CONNECTIVITY_CALENDAR_VISABILITY =
    'TOGGLE_CONNECTIVITY_CALENDAR_VISABILITY';
export const TOGGLE_CONNECTIVITY_CONFIG_FORM_VALID =
    'TOGGLE_CONNECTIVITY_CONFIG_FORM_VALID';
export const TOGGLE_CONNECTIVITY_MODAL = 'TOGGLE_CONNECTIVITY_MODAL';
export const TOGGLE_CONNECTIVITY_MODAL_PARTNER_DROPDOWN =
    ' TOGGLE_CONNECTIVITY_MODAL_PARTNER_DROPDOWN';
export const TOGGLE_CONNECTIVITY_MODAL_PRACTICE_DROPDOWN =
    'TOGGLE_CONNECTIVITY_MODAL_PRACTICE_DROPDOWN';
export const TOGGLE_CONNECT_CONFIG_MODAL = 'TOGGLE_CONNECT_CONFIG_MODAL';
export const TOGGLE_CONNECT_CONFIG_MODAL_COLLAPSE =
    'TOGGLE_CONNECT_CONFIG_MODAL_COLLAPSE';
export const TOGGLE_PLUGIN_DETAIL_MODAL = 'TOGGLE_PLUGIN_DETAIL_MODAL';
export const TOGGLE_CONNECT_PLUGIN_DETAIL_MODAL_COLLAPSE =
    'TOGGLE_CONNECT_PLUGIN_DETAIL_MODAL_COLLAPSE';
export const TOGGLE_CREATEPARTNERMODAL = 'TOGGLE_CREATEPARTNERMODAL';
export const TOGGLE_CREATEPRACTICEMODAL = 'TOGGLE_CREATEPRACTICEMODAL';
export const TOGGLE_CREATE_PARTNER_MODAL = 'TOGGLE_CREATE_PARTNER_MODAL';
export const TOGGLE_CREATE_PRACTICE_MODAL = 'TOGGLE_CREATE_PRACTICE_MODAL';
export const TOGGLE_DASHBOARD_VISIBLE = 'TOGGLE_DASHBOARD_VISIBLE';
export const TOGGLE_DELETE_SYNC_CONFIRMATION_MODAL =
    'TOGGLE_DELETE_SYNC_CONFIRMATION_MODAL';
export const TOGGLE_EDIT_FORM_TABLE_IS_EDITING =
    'TOGGLE_EDIT_FORM_TABLE_IS_EDITING';
export const TOGGLE_EDIT_GROUP_FORM_EDITING = 'TOGGLE_EDIT_GROUP_FORM_EDITING';
export const TOGGLE_EDIT_GROUP_FORM_IS_EDITING =
    'TOGGLE_EDIT_GROUP_FORM_IS_EDITING';
export const TOGGLE_EDIT_PARTNER_FORM_INVALID =
    'TOGGLE_EDIT_PARTNER_FORM_INVALID';
export const TOGGLE_EDIT_PARTNER_MODAL = 'TOGGLE_EDIT_PARTNER_MODAL';
export const TOGGLE_EDIT_PARTNER_MODAL_COLLAPSE =
    'TOGGLE_EDIT_PARTNER_MODAL_COLLAPSE';
export const TOGGLE_EDIT_PRACTICE_FORM_EDITING =
    'TOGGLE_EDIT_PRACTICE_FORM_EDITING';
export const TOGGLE_EDIT_PRACTICE_MODAL = 'TOGGLE_EDIT_PRACTICE_MODAL';
export const TOGGLE_EDIT_TAG_FORM_EDITING = 'TOGGLE_EDIT_TAG_FORM_EDITING';
export const TOGGLE_EDIT_TAG_FORM_IS_EDITING =
    'TOGGLE_EDIT_TAG_FORM_IS_EDITING';
export const TOGGLE_EDIT_USER_FORM_EDITING = 'TOGGLE_EDIT_USER_FORM_EDITING';
export const TOGGLE_EDIT_USER_FORM_IS_EDITING =
    'TOGGLE_EDIT_USER_FORM_IS_EDITING';
export const TOGGLE_GETTING_PRACTICE = 'TOGGLE_GETTING_PRACTICE';
export const TOGGLE_IGNORE_FAILED_SYNC_MODAL =
    'TOGGLE_IGNORE_FAILED_SYNC_MODAL';
export const TOGGLE_ASSIGN_USER_TO_PRACTICE_MODAL =
    'TOGGLE_ASSIGN_USER_TO_PRACTICE_MODAL';
export const TOGGLE_IS_PRACTICE_SUMMARY_OPEN =
    'TOGGLE_IS_PRACTICE_SUMMARY_OPEN';
export const TOGGLE_IS_RELATIONS_MODAL_OPEN = 'TOGGLE_IS_RELATIONS_MODAL_OPEN';
export const SET_RELATIONS_MODAL_WORKING_PRACTICE =
    'SET_RELATIONS_MODAL_WORKING_PRACTICE';
export const TOGGLE_NAVBAR_TOGGLER = 'TOGGLE_NAVBAR_TOGGLER';
export const TOGGLE_NEWPARTNERMODALCOLLAPSE = 'TOGGLE_NEWPARTNERMODALCOLLAPSE';
export const TOGGLE_NEW_GROUP_FORM = 'TOGGLE_NEW_GROUP_FORM';
export const TOGGLE_NEW_PARTNER_MODAL_COLLAPSE =
    'TOGGLE_NEW_PARTNER_MODAL_COLLAPSE';
export const TOGGLE_NEW_PRACTICE_MODAL = 'TOGGLE_NEW_PRACTICE_MODAL';
export const TOGGLE_NEW_TAG_FORM = 'TOGGLE_NEW_TAG_FORM';
export const TOGGLE_NEW_USER_FORM = 'TOGGLE_NEW_USER_FORM';
export const TOGGLE_PENDING_PRACTICE_MODAL = 'TOGGLE_PENDING_PRACTICE_MODAL';
export const TOGGLE_PRACTICE_CONFIG_MODAL = 'TOGGLE_PRACTICE_CONFIG_MODAL';
export const SET_CONFIG_MODAL_WORKING_PRACTICE =
    'SET_CONFIG_MODAL_WORKING_PRACTICE';
export const TOGGLE_REFRESH = 'TOGGLE_REFRESH';
export const TOGGLE_PRACTICE_REFRESH = 'TOGGLE_PRACTICE_REFRESH';
export const TOGGLE_REQUEST_FORM_INVALID = 'TOGGLE_REQUEST_FORM_INVALID';
export const TOGGLE_REQUEST_TAB_PARTNER_DROPDOWN =
    'TOGGLE_REQUEST_TAB_PARTNER_DROPDOWN';
export const TOGGLE_REQUEST_TAB_PRACTICE_DROPDOWN =
    'TOGGLE_REQUEST_TAB_PRACTICE_DROPDOWN';
export const TOGGLE_SIDEBAR_OPEN = 'TOGGLE_SIDEBAR_OPEN';
export const TOGGLE_SYNC_SCHEDULER_IS_EDITING =
    'TOGGLE_SYNC_SCHEDULER_IS_EDITING';
export const TOGGLE_TAG_CONNECTION_DROPDOWN = 'TOGGLE_TAG_CONNECTION_DROPDOWN';
export const TOGGLE_TAG_TIER_DROPDOWN = 'TOGGLE_TAG_TIER_DROPDOWN';
export const TOGGLE_WORKFLOW_CONFIG_MODAL = 'TOGGLE_WORKFLOW_CONFIG_MODAL';
export const TOGGLE_WORKFLOW_EDIT_PRACTICE_MODAL =
    'TOGGLE_WORKFLOW_EDIT_PRACTICE_MODAL';
export const TOGGLE_WORKFLOW_OFFERING_MODAL = 'TOGGLE_WORKFLOW_OFFERING_MODAL';
export const TOGGLE_WORKFLOW_SCHEDULE_MODAL = 'TOGGLE_WORKFLOW_SCHEDULE_MODAL';
export const SET_SCHEDULE_MODAL_WORKING_PRACTICE =
    'SET_SCHEDULE_MODAL_WORKING_PRACTICE';
export const TOGGLE_WORKFLOW_SELECT_MODAL = 'TOGGLE_WORKFLOW_SELECT_MODAL';
export const TOGGLE_WORKFLOW_TRANSITION = 'TOGGLE_WORKFLOW_TRANSITION';

export const TOGGLE_PLUGINOFFERING_ADD_MODAL =
    'TOGGLE_PLUGINOFFERING_ADD_MODAL';
export const TOGGLE_PLUGINOFFERING_ADD_MODAL_COLLAPSE =
    'TOGGLE_PLUGINOFFERING_ADD_MODAL_COLLAPSE';

export const UNSELECT_PRACTICE = 'UNSELECT_PRACTICE';
export const UPDATE_SCHEDULE_LIST = 'UPDATE_SCHEDULE_LIST';
export const UPDATE_STORED_COMMUNICATIONS = 'UPDATE_STORED_COMMUNICATIONS';
export const UPDATE_STORED_REQUESTS = 'UPDATE_STORED_REQUESTS';
export const USELESS_TOGGLE = 'USELESS_TOGGLE';
export const USERS_ERROR = 'USERS_ERROR';

export const SET_PIMS = 'SET_PIMS';

export const TOGGLE_SCHEDULE_MODAL = 'TOGGLE_SCHEDULE_MODAL';

export const TOGGLE_COMMUNICATIONS_TRANSITION =
    'TOGGLE_COMMUNICATIONS_TRANSITION';

export const SET_ASSIGNED_USER = 'SET_ASSIGNED_USER';

export const SET_COMMUNICATION_PARTNERS = 'SET_COMMUNICATION_PARTNERS';
export const SELECT_NEW_COMMUNICATION = 'SELECT_NEW_COMMUNICATION';
export const SET_INCLUDE_CLOSED_COMMUNICATIONS =
    'SET_INCLUDE_CLOSED_COMMUNICATIONS';

export const SET_SEARCH_PARTNER_OFFERINGS = 'SET_SEARCH_PARTNER_OFFERINGS';
export const SET_SEARCH_PRACTICE_PIMS = 'SET_SEARCH_PRACTICE_PIMS';

export const TOGGLE_UPDATE_NOTES_MODAL = 'TOGGLE_UPDATE_NOTES_MODAL';
export const SET_SITE_UPDATE_COUNTS = 'SET_SITE_UPDATE_COUNTS';
export const SET_SITE_UPDATES = 'SET_SITE_UPDATES';
export const SET_COMMUNICATION_ACTIVITY = 'SET_COMMUNICATION_ACTIVITY';
export const SET_INTERMEDIATE_ENTITY_COUNTS = 'SET_INTERMEDIATE_ENTITY_COUNTS';
export const SET_CONVERSION_OVERVIEW = 'SET_CONVERSION_OVERVIEW';
export const SET_MODAL_CONVERSION = 'SET_MODAL_CONVERSION';

export const TOGGLE_EDIT_CONVERSION_PIMS_MODAL =
    'TOGGLE_EDIT_CONVERSION_PIMS_MODAL';
export const TOGGLE_RESET_CONVERSION_MODAL = 'TOGGLE_RESET_CONVERSION_MODAL';
export const TOGGLE_CONVERSION_ACTIVITY_TRIAL =
    'TOGGLE_CONVERSION_ACTIVITY_TRIAL';
export const TOGGLE_CONVERSION_ACTIVITY_FINAL =
    'TOGGLE_CONVERSION_ACTIVITY_FINAL';
export const TOGGLE_CONVERSION_ACTIVITY_PAST_DUE =
    'TOGGLE_CONVERSION_ACTIVITY_PAST_DUE';
export const TOGGLE_CONVERSION_ACTIVITY_ONE_WEEK =
    'TOGGLE_CONVERSION_ACTIVITY_ONE_WEEK';
export const TOGGLE_CONVERSION_ACTIVITY_LATER =
    'TOGGLE_CONVERSION_ACTIVITY_LATER';
export const TOGGLE_CONVERSION_ACTIVITY_COMPLETE =
    'TOGGLE_CONVERSION_ACTIVITY_COMPLETE';
export const TOGGLE_CONVERSION_ACTIVITY_CLEAR =
    'TOGGLE_CONVERSION_ACTIVITY_CLEAR';
export const TOGGLE_REFRESH_ACTIVITIES = 'TOGGLE_REFRESH_ACTIVITIES';

export const TOGGLE_DAYLIGHT_CODE_REVIEW_MODAL =
    'TOGGLE_DAYLIGHT_CODE_REVIEW_MODAL';
export const SET_DAYLIGHT_CODES = 'SET_DAYLIGHT_CODES';
export const SET_DAYLIGHT_WORKING_PRACTICE = 'SET_DAYLIGHT_WORKING_PRACTICE';
export const SET_NEO_CODES = 'SET_NEO_CODES';
export const SET_INCOMING_NEO_CODES = 'SET_INCOMING_NEO_CODES';

export const TOGGLE_LEADS_GENERATION_CONFIRMATION_MODAL =
    'TOGGLE_LEADS_GENERATION_CONFIRMATION_MODAL';

export const TOGGLE_EDITING_PRACTICE = 'TOGGLE_EDITING_PRACTICE';

export const SET_PRACTICE_ID = 'SET_PRACTICE_ID';

export const TOGGLE_TEXT_PRACTICE_SEARCH = 'TOGGLE_TEXT_PRACTICE_SEARCH';
export const TOGGLE_PRACTICE_WORKFLOW_MODAL = 'TOGGLE_PRACTICE_WORKFLOW_MODAL';
export const ERROR = 'ERROR';

export const FETCH_PRACTICE_ALERTS = 'FETCH_PRACTICE_ALERTS';
export const FETCH_PRACTICE_ALERTS_ERROR = 'FETCH_PRACTICE_ALERTS_ERROR';
export const SAVE_PRACTICE_ALERT = 'SAVE_PRACTICE_ALERT';
export const SAVE_PRACTICE_ALERT_ERROR = 'SAVE_PRACTICE_ALERT_ERROR';
export const DELETE_PRACTICE_ALERT = 'DELETE_PRACTICE_ALERT';
export const DELETE_PRACTICE_ALERT_ERROR = 'DELETE_PRACTICE_ALERT_ERROR';
